import { useTranslation } from '../../../hooks/useTranslation';
import { PropertyUsage } from '../../../__generated__/pge-types';
import { addDays, isWithinInterval, set } from 'date-fns';

const { t } = useTranslation();

export const validatePropertyUsage = (propertyUsage?: PropertyUsage) => {
  if (!propertyUsage) {
    return t('PROPERTY_USAGE_ERROR');
  }
  return null;
};

export const validateSSMMoveStopDate = (date?: Date): string | null => {
  if (!date) {
    return t('SSM_MOVE_SELECT_STOP_DATE');
  }
  if (date) {
    const start = set(new Date(), {
      hours: 0,
      minutes: 0,
      seconds: 0,
      milliseconds: 0,
    });

    if (!isWithinInterval(date, { start, end: addDays(start, 90) })) {
      return t('SSM_MOVE_STOP_DATE_OUT_OF_RANGE');
    }
  }
  return null;
};
